<template>
    <div class="survey-tabs">
        <a :class="['TMGeneralButton', 'blue-border', {active: current_tab == 'in_person'}]" @click="setSurveyFormat('in_person')" v-show="show_in_person">
            In Person
        </a>
        <a :class="['TMGeneralButton', 'blue-border', {active: current_tab == 'online'}]" @click="setSurveyFormat('online')" v-show="show_online">
            Online
        </a>
    </div>
</template>
<script>
export default {
    name: "SurveyFormatTabs",
    props: ['current_tab', 'current_group'],
    data() {
        return {
            surveys: Object.values(this.current_group.surveys)
        }
    },
    methods: {
        setSurveyFormat(format) {
            this.$emit('surveyFormat', format);
        }
    },
    computed: {
        show_in_person() {
            for (var i = 0; i < this.surveys.length; i++) {
                let e = this.surveys[i];
                if (e.survey && e.survey.format === 'in_person') {
                    return true
                }
            }
            return false
        },
        show_online() {
            for (var i = 0; i < this.surveys.length; i++) {
                let e = this.surveys[i];
                if (e.survey && e.survey.format === 'online') {
                    return true
                }
            }
            return false
        }
    }
}
</script>
<style lang="less">
@import "../../assets/components/sendSurvey/SurveyFormatTabs.less";
@import "../../assets/components/common/TMGeneralButton.less";
</style>